import React from "react";
import { Link, useSearchParams } from "react-router-dom";
import ManageAccountsIcon from "@mui/icons-material/ManageAccounts";
import KeyRoundedIcon from "@mui/icons-material/KeyRounded";
import BadgeRoundedIcon from "@mui/icons-material/BadgeRounded";
import UserDirectory from "./Access/UserDirectory";
import UserAutomation from "./Access/UserAutomation";
import { TabBar } from "./Access/accessUi";
import { PageHeader, PageShell } from "../../components/UI/Page";

const TABS = [
  { value: "people", label: "People" },
  { value: "automation", label: "Automation" },
];

const UserManagement = () => {
  // ?tab=automation from the directory sync's admin notifications.
  const [searchParams, setSearchParams] = useSearchParams();
  const tab = searchParams.get("tab") === "automation" ? "automation" : "people";

  return (
    <PageShell size="2xl">
      <PageHeader
        icon={ManageAccountsIcon}
        tone="slate"
        eyebrow="Admin"
        eyebrowTo="/admin"
        title="User Manager"
        description="Find people, change their roles and branch, and give them access to single pages. Changes reach them within about 20 seconds — nobody has to sign out."
        actions={
          <>
            <Link to="/admin/access?tab=roles" className="app-btn app-btn-secondary">
              <BadgeRoundedIcon sx={{ fontSize: 18 }} />
              Roles
            </Link>
            <Link to="/admin/access" className="app-btn app-btn-secondary">
              <KeyRoundedIcon sx={{ fontSize: 18 }} />
              Page Access
            </Link>
          </>
        }
      />

      <div className="mb-5">
        <TabBar
          label="User Manager sections"
          tabs={TABS}
          value={tab}
          onChange={(value) => setSearchParams(value === "people" ? {} : { tab: value }, { replace: true })}
        />
      </div>

      {tab === "people" ? <UserDirectory /> : <UserAutomation />}
    </PageShell>
  );
};

export default UserManagement;
